<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
  </cTable>
</template>

<script>
import {
  getShipment,
  refShipments,
  exportOutBound,
  getTags,
  createBill,
  cancelHang
} from "@/api/finance/shipment";
import { getAllClient, getCompanies } from "@/api/user/client";
import { getContractParams } from "@/api/user/contract";
import { getCountry } from "@/api/system/country";

import cTable from "@/base/common/index";
export default {
  name: "shipment",
  components: {
    cTable
  },
  data() {
    return {
      methods: {
        list: getShipment,
        refShipments,
        exportOutBound,
        getAllClient,
        getTags,
        getContractParams,
        cancelHang,
        beforeHandleList({ data }) {
          if (!this.pushTableTitle) {
            let obj = {
              name: this.$t("cost_fee"),
              children: []
            };
            let newObj = data.rows[0].cost_name;
            Object.keys(newObj).forEach(key => {
              this.pushTableTitle = true;
              let data = {
                name: newObj[key],
                key: key,
                minWidth: 145,
                methods: {
                  render({ row }) {
                    return row.cost[key].toString();
                  }
                }
              };
              obj.children.push(data);
            });
            this.fields.push(obj);
          }
          return;
        },
        createBill
      },
      config: {
        height: 630,
        contentMethod({ row, column }) {
          if (column.type == "status" && row.msg) {
            return row.msg;
          }
        }
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              let data = row;
              data.ids = this.$page.selectAll.map(
                item => item.airway_bill_number
              );
              this.$page.handleRequestMethods("createBill", data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            title: this.$t("createBill"),
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          grid: [{ name: 24 }, { show_sku: 24 }, { remarks: 24 }],
          fields: [
            {
              name: this.$t("codNAme"),
              key: "name",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("codNAme")
            },
            {
              name: this.$t("whether") + this.$t("show1") + "SKU",
              key: "show_sku",
              component: "Radio",
              placeholder: () =>
                this.$t("select") +
                this.$t("whether") +
                this.$t("show1") +
                "SKU",
              options: [
                { label: this.$t("YES"), value: 1 },
                { label: this.$t("NO"), value: 0 }
              ],
              default: 0,
              bind: {
                border: true
              }
            },
            {
              name: this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Remarks"),
              bind: {
                type: "textarea",
                rows: 5
              }
            }
          ]
        },
        feeModal: {
          config: {
            modalBind: {
              draggable: true,
              transfer: true,
              width: 600
            },
            modalContentBind: {
              style: {
                height: "600px"
              }
            }
          },
          table: {
            config: {
              height: 600
            },
            fields: [
              {
                name: () => this.$t("expense"),
                key: "expense_item_name"
              },
              {
                name: () => this.$t("cost_t") + "(USD)",
                key: "amount_usd"
              },
              {
                name: () => this.$t("cost_t") + "(CNY)",
                key: "amount_cny"
              }
            ]
          },
          footer: {
            show: () => false
          }
        }
      },
      header: {
        searchs: [
          {
            key: "dateType",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("date") + this.$t("type");
            },
            clearable: false,
            options: [
              { label: this.$t("outbound_time"), value: 2 },
              {
                label: this.$t("inboundTime"),
                value: 3
              }
            ],
            bind: {
              style: "width:150px"
            },
            default: 2
          },
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              "on-change"({ searchForm }) {
                searchForm.startTime = searchForm.startTime
                  ? this.$page.format.timeFormat(searchForm.startTime)
                  : "";
              }
            }
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("end") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              "on-change"({ searchForm }) {
                let time = this.$page.format.timeFormat(searchForm.endTime);
                if (time.slice(-8) === "00:00:00") {
                  time = time.split(" ")[0] + " " + "23:59:59";
                  searchForm["endTime"] = time;
                }
              }
            }
          },

          {
            key: "client_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            clearable: true,
            options: [],
            default: [],
            config: { label: "account", value: "id" },
            bind: {
              style: "width:200px",
              multiple: true,
              "max-tag-count": 1
            }
          },
          {
            key: "ownership",
            placeholder() {
              return this.$t("select") + this.$t("ownership");
            },
            component: "Select",
            options: [],
            config: {
              label: "title",
              value: "id"
            }
          },
          {
            key: "status",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("exlType");
            },
            clearable: true,
            options: [
              { label: this.$t("billFailed"), value: 0 },
              {
                label: this.$t("billSuccess"),
                value: 1
              }
            ],
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "finance_status",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("codTypes");
            },
            clearable: true,
            options: [
              { label: this.noOrder("noOrder"), value: 0 },
              { label: this.$t("isOrder"), value: 1 },
              { label: this.$t("objection"), value: 3 },
              { label: this.$t("Settled"), value: 9 }
            ],
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "c_title",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("contract_title");
            },
            clearable: true,
            options: [],
            config: {
              label: "title",
              value: "id"
            },
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "tag",
            component: "Select",
            placeholder() {
              return this.$t("select") + "Tags";
            },
            clearable: true,
            options: [],
            config: {
              label: "value",
              value: "key"
            },
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "countryCode",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("target_country");
            },
            clearable: true,
            options: [],
            config: {
              label: "code",
              value: "code"
            },
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "keywordsType",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("keyword") + this.$t("type");
            },
            clearable: true,
            options: [
              { label: this.$t("orderNum"), value: "1" },
              { label: this.$t("packing_number"), value: "2" },
              { label: this.$t("mawb"), value: "3" }
            ],
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              style: "width:140px",
              type: "textarea",
              rows: 1
            },
            component: "Input"
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("createBill"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning"
              }
            },
            {
              name: () => this.$t("reStatistics"),
              type: "reStatistics",
              fnName: "reStatistics",
              bind: {
                type: "warning",
                icon: "md-refresh"
              },
              disabled() {
                return !this.selectAll.length;
              }
              // id: 138
            },

            {
              name: () => this.$t("cancel") + this.$t("hang"),
              type: "cancelHang",
              fnName: "cancelHang",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                // icon: "md-arrow-down",
                type: "primary"
              }
              // id: 722
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              // disabled() {
              //   return !this.selectAll.length;
              // },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
              // id: 302
            }
          ],
          methods: {
            add({ searchForm }) {
              this.getModal("add").open(searchForm);
            },
            export({ searchForm }) {
              this.openLoading();
              let data = searchForm;
              data.export = 1;
              this.handleRequestMethods("list", data, false, true).then(res => {
                window.open(this.$globalUrl + res.payload, "_blank");
                this.closeLoading();
              });
            },
            cancelHang() {
              this.$Modal.confirm({
                title: this.$t("cancel") + this.$t("hang"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  let data = {
                    ids: this.selectAll.map(item => {
                      return item.airway_bill_number;
                    })
                  };
                  this.handleRequestMethods("cancelHang", data).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            },
            reStatistics() {
              this.$Modal.confirm({
                title: this.$t("reStatistics"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  let data = {
                    airway_number: this.selectAll.map(item => {
                      return item.airway_bill_number;
                    })
                  };
                  this.handleRequestMethods("refShipments", data).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          fixed: "left",
          width: 60
        },
        {
          name: () => this.$t("order_number"),
          key: "airway_bill_number",
          minWidth: 130,
          fixed: "left"
        },
        {
          name: () => this.$t("packing_number"),
          key: "packing_number",
          minWidth: 130
        },
        {
          name: () => this.$t("inboundTime"),
          key: "inbound_time",
          width: 170
        },
        {
          name: () => this.$t("outbound_time"),
          key: "outbound_time",
          width: 170
        },
        {
          name: () => this.$t("trajectory"),
          children: [
            {
              name: () => this.$t("code"),
              key: "tracker_code",
              width: 95,
              methods: {
                render: ({ row }) => {
                  return row.shipments ? row.shipments.status : "-";
                }
              }
            },
            {
              name: () => this.$t("tracker_description"),
              key: "tracker_description",
              width: 110,
              methods: {
                render: ({ row }) => {
                  return row.shipments ? row.shipments.status_remarks : "-";
                }
              }
            },
            // {
            //   name: () => this.$t("tracker_description_cn"),
            //   key: "status_cn",
            //   minWidth: 100,
            //   methods: {
            //     render: ({ row }) => {
            //       return row.shipments ? row.shipments.status_cn : "-";
            //     }
            //   }
            // },
            {
              name: () => this.$t("update") + this.$t("time"),
              key: "status_time",
              width: 170,
              methods: {
                render: ({ row }) => {
                  return row.shipments ? row.shipments.status_time : "-";
                }
              }
            }
          ]
        },
        {
          name: () => this.$t("bill_number"),
          key: "bill_number",
          width: 110,
          methods: {
            render: ({ row }) => {
              return row.bill ? row.bill.bill_number : " - ";
            }
          }
        },
        {
          name: () => this.$t("clientName"),
          key: "client_name",
          width: 95,
          methods: {
            render: ({ row }) => {
              return row.clientInfo ? row.clientInfo.account : " - ";
            }
          }
        },
        {
          name: () => this.$t("ownership"),
          key: "ownership_name",
          align: "left",
          minWidth: 160
        },
        {
          name: () => this.$t("contract_title"),
          align: "left",
          key: "main_contract_header_txt",
          width: 110
        },
        {
          name: () => this.$t("salesman"),
          width: 95,
          key: "salesman",
          methods: {
            render: ({ row }) => {
              return row.clientInfo.salesman
                ? row.clientInfo.salesman.account
                : " - ";
            }
          }
        },
        {
          name: () => this.$t("codTypes"),
          key: "finance_status_txt",
          width: 130
        },
        {
          name: () => this.$t("channel_code"),
          key: "transport_mode",
          width: 95
        },

        {
          name: () => this.$t("shipment_place"),
          key: "warehouse",
          minWidth: 100
        },
        {
          name: () => this.$t("mawb"),
          key: "mawb",
          minWidth: 100
        },
        {
          name: () =>
            this.$t("invoicePCS") + "(" + this.$t("case_number") + ")",
          key: "quantity",
          minWidth: 100
        },
        {
          name: this.$t("agentT"),
          children: [
            {
              name: () => this.$t("crossPort"),
              key: "packing_agent",
              minWidth: 100
            },
            {
              name: () => this.$t("clearance"),
              key: "clearance_agent",
              minWidth: 100
            },
            {
              name: () => this.$t("air_transport"),
              key: "air_agent",
              minWidth: 100
            },
            {
              name: () => this.$t("delivery_t"),
              key: "shipments",
              minWidth: 100,
              methods: {
                render({ value }) {
                  return value.deliver;
                }
              }
            }
          ]
        },
        {
          name: () => this.$t("countryCode"),
          key: "country_code",
          width: 95
        },
        {
          name: () => () => this.$t("city_t"),
          children: [
            {
              name: () => this.$t("alipay_name"),
              key: "city_name",
              width: 95,
              methods: {
                render: ({ row }) => {
                  return row.shipments ? row.shipments.city_name : "";
                }
              }
            },
            {
              name: () => this.$t("RemoteRegions"),
              key: "remote_areas",
              width: 110,
              methods: {
                render: ({ value }) => {
                  return value && value != 0 ? this.$t("YES") : this.$t("NO");
                }
              }
            }
          ]
        },

        {
          name: () => this.$t("values"),
          key: "values",
          width: 100
        },
        {
          name: () => this.$t("Collection_t"),
          children: [
            {
              name: () => this.$t("reChAmount"),
              key: "cod_amount",
              width: 95
            },

            {
              name: () => this.$t("type"),
              key: "cod_type",
              width: 130
            }
          ]
        },
        {
          name: () => this.$t("currency_t"),
          children: [
            {
              name: () => this.$t("Collection_t"),
              key: "replace_currency",
              width: 95
            },
            {
              name: () => this.$t("receivable"),
              key: "freight_unit",
              width: 95
            }
          ]
        },
        {
          name: () => this.$t("Weight"),
          children: [
            {
              name: () => this.$t("claim_weight"),
              key: "claim_weight",
              width: 95
            },
            {
              name: () => this.$t("skuVolume"),
              key: "charge_volume",
              width: 95
            },
            {
              name: () => this.$t("Billing"),
              key: "charge_params",
              width: 95
            },
            {
              name: () => this.$t("amount_actual"),
              key: "actual_weight",
              width: 95
            }
          ]
        },
        {
          name: "USD",
          children: [
            {
              name: () => this.$t("freight_append"),
              key: "other_fee_usd",
              width: 110,
              component: "Button",
              bind: {
                type: "primary",
                size: "small"
              },
              methods: {
                click({ row }) {
                  this.$page.getModal("feeModal").open({ row }, function() {
                    this.setTitle(
                      this.$t("freight_append") +
                        "(" +
                        row.airway_bill_number +
                        ")"
                    );
                    this.list = row.otherFeeItem;
                  });
                }
              }
            },
            {
              name: () => this.$t("freight_fees"),
              key: "freight_fees_usd",
              minWidth: 120
            },
            {
              name: () => this.$t("total_tax"),
              key: "total_tax_usd",
              minWidth: 120
            },
            {
              name: () => this.$t("vat_fee"),
              key: "vat_fee_usd",
              minWidth: 130
            },
            {
              name: () => this.$t("tax_fee"),
              key: "tax_fee_usd",
              minWidth: 110
            },
            {
              name: () => this.$t("document_fee"),
              key: "document_fee_usd",
              minWidth: 110
            }
          ]
        },
        {
          name: "CNY",
          children: [
            {
              name: () => this.$t("freight_append"),
              key: "other_fee_cny",
              minWidth: 110,
              component: "Button",
              bind: {
                type: "primary",
                size: "small"
              },
              methods: {
                click({ row }) {
                  this.$page.getModal("feeModal").open({ row }, function() {
                    this.setTitle(
                      this.$t("freight_append") +
                        "(" +
                        row.airway_bill_number +
                        ")"
                    );
                    this.list = row.otherFeeItem;
                  });
                }
              }
            },
            {
              name: () => this.$t("freight_fees"),
              key: "freight_fees_cny",
              minWidth: 110
            },
            {
              name: () => this.$t("total_tax"),
              key: "total_tax_cny",
              minWidth: 110
            },
            {
              name: () => this.$t("vat_fee"),
              key: "vat_fee_cny",
              minWidth: 110
            },
            {
              name: () => this.$t("tax_fee"),
              key: "tax_fee_cny",
              minWidth: 110
            },
            {
              name: () => this.$t("document_fee"),
              key: "document_fee_cny",
              minWidth: 110
            }
          ]
        },
        {
          name: () => this.$t("exlType"),
          key: "status",
          fixed: "right",
          type: "status",
          minWidth: 80,
          bind: {
            style({ row }) {
              return {
                color: row.status == "1" ? "#4caf50" : "#f44336"
              };
            }
          },
          methods: {
            render: ({ row }) => {
              return row.status == 0
                ? this.$t("billFailed")
                : this.$t("billSuccess");
            }
          }
        },
        {
          name: () => "Tag",
          key: "tag_txt",
          fixed: "right",
          minWidth: 80
        }
        // {
        //   type: "btns",
        //   width: 150,
        //   name: this.$t("operation"),
        //   fixed: "right",
        //   // width({ field }) {
        //   //   return field.list.length * 40 + 40;
        //   // },
        //   list: [
        //     {
        //       name: this.$t("update"),
        //       type: "update",
        //       fnName: "update",
        //       bind: {
        //         type: "success"
        //       }
        //     },
        //     {
        //       name: this.$t("delete"),
        //       type: "delete",
        //       fnName: "delete",
        //       bind: {
        //         type: "error"
        //       }
        //     }
        //   ],
        //   methods: {
        //     update({ row }) {
        //       this.handleRequestMethods("getDetails", row.id).then(res => {
        //         this.getModal("add").setTitle(this.$t("update"));
        //         this.getModal("add").type = "update";
        //         this.getModal("add").open(res.payload);
        //       });
        //     },
        //     delete({ row }) {
        //       this.$Modal.confirm({
        //         title: this.$t("delete"),
        //         width: 300,
        //         content: this.$t("titleModal"),
        //         onOk: () => {
        //           this.handleRequestMethods("del", row.id).then(res => {
        //             this.$Message["success"]({
        //               background: true,
        //               content: res.msg
        //             });
        //             this.getList();
        //           });
        //         }
        //       });
        //     }
        //   }
        // }
      ]
    };
  },
  mounted() {
    this.header.searchs.forEach(async item => {
      if (item.key === "client_id")
        item.options = (await getAllClient()).data.payload.rows;
      if (item.key === "ownership")
        item.options = (await getCompanies()).data.payload;
      if (item.key === "tag") item.options = (await getTags()).data.payload;
      if (item.key === "c_title")
        item.options = (await getContractParams()).data.payload.header;
      if (item.key === "countryCode")
        item.options = (
          await getCountry({ allow_arrive: 1 })
        ).data.payload.rows;
    });
  }
};
</script>
